import React from "react";
import "./nousers.css"
import { GiEmptyHourglass } from "react-icons/gi";

function NoUsers() {
  return (
    <div className="dashboard-container">
      <div className="empty-state-card">
        {/* <div className="illustration">
         <GiEmptyHourglass />...
        </div> */}
        <h1 className="title">Welcome to Your Dashboard</h1>
        <p className="subtitle">
          Create a client or user to solve your tickets. Get started by adding your first team member or client account.
        </p>
        <div className="steps-container">
          <div className="step-indicator">
            <div className="step">
              <div className="step-icon">📋</div>
              <span className="step-label">Menu</span>
            </div>
            <div className="step-arrows">→</div>
             <div className="step">
              <div className="step-icon">📋</div>
              <span className="step-label">Create a Client</span>
            </div>
            <div className="step-arrows">→</div>
            <div className="step active">
              <div className="step-icon">👥</div>
              <span className="step-label">Create a User</span>
            </div>
          </div>
          <p className="steps-hint">
            Follow these steps to set up your first client and start managing tickets.
          </p>
        </div>
        <div className="features-hint">
          <p>Unlock features like ticket assignment, real-time collaboration, and analytics once you add users.</p>
        </div>
      </div>
    </div>
  );
}

export default NoUsers;
